<template>
  <va-card :title="title">
    <template slot="actions">
      <va-button icon="fa fa-refresh" color="info" @click="refresh()" />
      <va-button icon="fa fa-gear" color="info" />
    </template>
    <div class="row mb-1">
      <div class="flex xs12 sm6">
        <va-input
          v-if="searchMode == true"
          class="ma-0"
          :value="term"
          :placeholder="$t('search.searchByEmployee')"
          @input="search"
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div v-if="showFilterRange == true" class="flex xs12 sm6">
        <va-date-picker
          :label="rangeLabel"
          :config="{mode: 'range', dateFormat: 'd/M/Y'}"
          v-model="filterRange">
        </va-date-picker>
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="15"
      :loading="loadingProxy"
      clickable
      @row-clicked="rowClicked"
      hoverable
    >
      <template slot="icon">
        <va-icon name="fa fa-user" color="secondary" />
      </template>
      <template v-if="canDownload == true" slot="actions" slot-scope="props">
        <va-button
          flat
          small
          color="info"
          icon="fa fa-download"
          @click="downloadTimesheet(props.rowData)"
        />
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import { debounce } from 'lodash'
import timesheetService from '../../api/timesheetService'
import userCacheService from '../../api/userCacheService'
import {
  adminFieldsList,
  managerFieldsList,
  employeeFieldsList,
} from '../../data/fieldList'

export default {
  name: 'timesheet-list',
  props: {
    timesheets: Array,
    loading: Boolean,
    searchMode: Boolean,
    totalHours: Number,
    title: String,
    canDownload: Boolean,
    showFilterRange: Boolean,
  },
  data () {
    return {
      term: '',
      rangeLabel: 'Specify date range to show timesheets',
      filterRange: '',
      selectedTimesheet: undefined,
    }
  },
  computed: {
    filteredData () {
      if (!this.term || this.term.length < 1) {
        if (this.timesheetProxy.length > 0) {
          if (this.selectedTimesheet === undefined) {
            console.log('in filter data')
            this.selectRow(this.timesheetProxy[0])
          }
        }
        return this.timesheetProxy
      }
      var timesheets = this.timesheetProxy.filter(item => {
        return item.employee_name
          .toLowerCase()
          .includes(this.term.toLowerCase())
      })
      if (timesheets.length > 0 && this.selectedTimesheet !== undefined) {
        var id = this.selectedTimesheet.id
        var foundTimsheet = timesheets.find(function (item) { return item.id === id })
        if (foundTimsheet === undefined) {
          this.selectRow(timesheets[0])
        }
      }
      return timesheets
    },
    timesheetProxy () {
      return this.timesheets
    },
    loadingProxy () {
      return this.loading
    },
    fields () {
      var user = userCacheService.getCurrentUser()
      if (user.roles.admin || user.roles.super_admin) {
        return adminFieldsList.fields
      } else if (user.roles.manager) {
        return managerFieldsList.fields
      } else {
        return employeeFieldsList.fields
      }
    },
  },
  watch: {
    filterRange (range) {
      this.refreshList(true)
    },
  },
  created () {
    window.addEventListener('keyup', this.doCommand)
  },
  destroyed () {
    window.removeEventListener('keyup', this.doCommand)
  },
  methods: {
    doCommand (e) {
      if (e.keyCode === 27 && ((e.target.tagName === 'INPUT' && e.target.className === 'va-input__container__input') || (e.target.tagName === 'BODY'))) {
        this.clearFilterRange()
        console.log('1')
      }
    },
    refreshList (filterChanging) {
      if (this.filterRange !== '') {
        var values = this.filterRange.split(' ')
        if (values.length === 3) {
          console.log('2')
          var startString = values[0]
          var endString = values[2]
          var start = new Date(startString)
          var end = new Date(endString)
          this.$emit('refreshList', start, end)
          return
        }
      }
      if (!filterChanging) {
        console.log('3')
        this.$emit('refreshList')
      }
    },
    rowClicked (item) {
      this.$emit('selectedTimesheetChanged', item)
      this.selectedTimesheet = item
    },
    selectRow (item) {
      this.$emit('selectedTimesheetChanged', item)
      this.selectedTimesheet = item
    },
    refresh () {
      this.refreshList(false)
    },
    clearFilterRange () {
      var values = this.filterRange.split(' ')
      if (values.length === 3) {
        console.log('4')
        this.$emit('refreshList')
      }
      this.filterRange = ''
    },
    async downloadTimesheet (entry) {
      try {
        const response = await timesheetService.download(entry.id)
        const blob = new Blob([response])
        if (blob.size < 1024) {
          this.showError(
            'Error happened in downloading the file from server. file seems to be empty!'
          )
        } else {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const employee = entry.employee_name//.replaceAll(' ', '_')
          const period = entry.period
          const fileName = 'timesheet-' + employee + '-' + period + '-' + entry.id + '.pdf'
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.showMessage(
            'Timesheet file ' +
              fileName +
              ' has been downloaded'
          )
        }
      } catch (exception) {
        this.showError(exception)
      }
    },
    showMessage (message) {
      this.showToast(message, {
        icon: 'fa-check',
        position: 'bottom-right',
        duration: 5000,
      })
    },
    showError (message) {
      console.log(message)
      this.showToast(message, {
        icon: 'fa-exclamation',
        position: 'bottom-right',
        duration: 5000,
      })
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style lang="scss">
</style>
